//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//components
import Translation from '../../components/translation/translation';

//data
import dataSiteMap from '../../siteMap.json';
import dataTranslations from './translations.json';

//assets
import './footer.css';
import imgMundipharmaLogo from './mundipharma-logo.png';
import imgMundipharmaLogoContentPage from './mundipharma-logo-content-page.png';
import imgNappLogo from './napp-logo.png';
import imgNappLogoContentPage from './napp-logo-content-page.png';

class Footer extends Component {
	jumpToPageTop() {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}

	render() {
		let culture = this.props.culture;
		const cultureFallback = 'global'; //global set as the default culture
		const section = this.props.section;

		if (!dataSiteMap[culture]) {
			culture = cultureFallback;
		}

		let navItems = null;

		let footerClass = 'footer';
		let logoAlt = 'Mundipharma logo';
		let logoSource = imgMundipharmaLogo;

		if (culture === 'uk' && dataSiteMap.uk.live) {
			logoAlt = 'Napp logo';
			logoSource = imgNappLogo;
		}

		if (this.props.contentPage) {
			footerClass += ' footer--content-page';
			logoSource = imgMundipharmaLogoContentPage;

			if (culture === 'uk' && dataSiteMap.uk.live) {
				logoSource = imgNappLogoContentPage;
            }
		}

		if (dataSiteMap[culture].navigation.legal) {
			navItems = dataSiteMap[culture].navigation.legal.pages.map((record, index) => {
				if (!record.live) {
					return null;
				}

				let linkTo = '/uk/' + record.key;

				if (culture && section && (section !== 'terms-of-use' && section !== 'privacy-policy' && section !== 'cookie-policy' && section !== 'report-a-side-effect' && section !== 'contact-us')) {
					linkTo = '/' + culture + '/' + section + '/' + record.key;
				} else if (culture) {
					linkTo = '/' + culture + '/' + record.key;
				}

				return (
					<Link className="footer__nav__item" dangerouslySetInnerHTML={{ __html: record.__htmlName }} hrefLang={culture === 'global' ? 'en' : dataSiteMap[culture].cultureCode} key={index} onClick={this.jumpToPageTop} to={linkTo} />
				);
			});
		}

		return (
			<footer className={footerClass}>
				<div className="container">
					<div className="container__row">
						<div className="container__column container__column--bottom">
							<nav className="footer__nav">
								{navItems}
							</nav>
							<small><Translation culture={culture} data={dataTranslations} name="legal" /></small>
							<small><Translation culture={culture} data={dataTranslations} name="copyright" /></small>
						</div>
						<div className="container__column container__column--bottom">
							<img alt={logoAlt} className="footer__logo" src={logoSource} />
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js